import axios from "axios";

const client = axios.create({
  baseURL: import.meta.env.VITE_APP_GENERIC_FORM_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": import.meta.env.VITE_APP_GENERIC_FORM_API_KEY_OPS,
  },
});

export const getQuestionsByPageId = (pageId) => {
  try {
    const response = client.get(`/pages/public/${pageId}/questions`);
    return response;
  } catch (error) {
    console.error("Error in getQuestionsByPageId:", error);
    throw error;
  }
};

export const getFormConfigByFormtype = async (formType) => {
  try {
    const response = await client.get(
      `/form_config/public/by_form_type/${formType}`
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener form_config:", error);
    throw error;
  }
};

export const getFormStatusByWebUri = async (web_uri) => {
  // Validación del web_uri
  if (!web_uri || web_uri.trim() === "") {
    throw new Error("web_uri is empty or invalid");
  }

  try {
    const response = await client.get(`/forms/public/status/weburi/${web_uri}`);
    return response.data;
  } catch (error) {
    console.error("Error in getFormStatusByWebUri:", error);

    // Manejo específico de errores
    if (error.response?.status === 404) {
      throw new Error(
        `Form not found for web_uri: "${web_uri}". Please verify the URI exists in the database.`
      );
    } else if (error.response?.status === 401) {
      throw new Error("Unauthorized. Please check your API key.");
    } else if (error.response?.status === 403) {
      throw new Error(
        "Forbidden. You don't have permission to access this resource."
      );
    } else if (error.code === "NETWORK_ERROR") {
      throw new Error(
        "Network error. Please check your internet connection and API endpoint."
      );
    } else {
      throw new Error(`API Error: ${error.message}`);
    }
  }
};

export const getPagesByWebUri = async (web_uri) => {
  // Validación del web_uri
  if (!web_uri || web_uri.trim() === "") {
    return { data: [] };
  }

  try {
    const response = await client.get(`/forms/public/weburi/${web_uri}/pages`);
    return response;
  } catch (error) {
    console.error("Error in getPagesByWebUri:", error);
    // Si hay error, devolvemos un array vacío en lugar de fallar
    return { data: [] };
  }
};

export const postFormAnswersByWebUri = async ({
  web_uri,
  answers,
  behavioral_answers,
  form_id = null,
}) => {
  try {
    let finalFormId = form_id;

    // Si no tenemos form_id, intentamos obtenerlo del API
    if (!finalFormId) {
      const form_status = await getFormStatusByWebUri(web_uri);

      if (!form_status.form_found) {
        throw new Error("Form not found for the given web URI.");
      }

      finalFormId = form_status.form_id;
    }

    const response = await client.post("/form_answers/public/", {
      form_id: finalFormId,
      answers: answers,
      behavioral_answers: behavioral_answers,
    });

    return response.data;
  } catch (error) {
    console.error("Error in postFormAnswersByWebUri:", error);
    throw error;
  }
};
